import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { categoryId: Number }

  get ingredientsContainer() {
    return this.element.querySelector("[id^='category_'][id$='_ingredients']")
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
    const container = this.ingredientsContainer
    if (container) {
      container.classList.add("bg-electric/10", "ring-2", "ring-electric/40", "ring-inset")
    }
  }

  dragleave(_event) {
    const container = this.ingredientsContainer
    if (container) {
      container.classList.remove("bg-electric/10", "ring-2", "ring-electric/40", "ring-inset")
    }
  }

  async drop(event) {
    event.preventDefault()
    const container = this.ingredientsContainer
    if (container) {
      container.classList.remove("bg-electric/10", "ring-2", "ring-electric/40", "ring-inset")
    }

    const data = JSON.parse(event.dataTransfer.getData("application/json"))
    const { ingredientId, sourceCategoryId } = data
    const targetCategoryId = this.categoryIdValue

    if (String(sourceCategoryId) === String(targetCategoryId)) {
      return
    }

    const turboFrame = document.getElementById(`ingredient_${ingredientId}`)
    if (turboFrame) {
      this.performOptimisticMove(turboFrame, sourceCategoryId)
    }

    await this.moveIngredient(ingredientId, targetCategoryId)
  }

  performOptimisticMove(turboFrame, sourceCategoryId) {
    const sourceContainer = document.getElementById(`category_${sourceCategoryId}_ingredients`)
    const targetContainer = this.ingredientsContainer

    if (!targetContainer) return

    const emptyMsg = targetContainer.querySelector("p.text-center")
    if (emptyMsg) emptyMsg.remove()

    targetContainer.prepend(turboFrame)

    const innerDiv = turboFrame.querySelector("[data-pantry-drag-category-id-value]")
    if (innerDiv) {
      innerDiv.dataset.pantryDragCategoryIdValue = this.categoryIdValue
    }

    if (sourceContainer) {
      const remaining = sourceContainer.querySelectorAll("turbo-frame").length
      if (remaining === 0) {
        const msg = document.createElement("p")
        msg.className = "font-mono text-xs text-cream/20 py-6 text-center"
        msg.textContent = "Sin ingredientes"
        sourceContainer.appendChild(msg)
      }
    }
  }

  async moveIngredient(ingredientId, categoryId) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    try {
      await fetch("/pantry/move_ingredient", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: `ingredient_id=${ingredientId}&category_id=${categoryId}`
      })
    } catch (e) {
      console.error("Failed to move ingredient", e)
    }
  }
}
